import { render, staticRenderFns } from "./AccountTabTable.vue?vue&type=template&id=2d8bfe64&"
import script from "./AccountTabTable.vue?vue&type=script&lang=js&"
export * from "./AccountTabTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports